import { createAction, props } from '@ngrx/store';

import { BackendResponse } from 'src/app/core/interfaces/shared.interface';
import { SubscriptionsParams, Subscription } from '../subscriptions.interface';

export const setSubscriptions = createAction(
  '[Subscriptions Component] Set Subscriptions',
  props<{ subscriptions: BackendResponse<Subscription>; params: SubscriptionsParams; pageNumber: number }>()
);

export const updateSubscription = createAction('[Subscriptions Component] Update Subscription', props<{ subscription: Subscription }>());

export const changeManySubscriptionsStatus = createAction(
  '[Subscriptions Component] Change Many Subscriptions Status',
  props<{ payload: { ids: string[]; subscribed: string } }>()
);

export const updateManySubscriptions = createAction(
  '[Subscriptions Component] Update Many Subscriptions',
  props<{ subscriptions: Subscription[] }>()
);

export const switchSelection = createAction('[Subscriptions Component] Switch Selection', props<{ id: string }>());

export const switchAllSelection = createAction('[Subscriptions Component] Switch All Selection', props<{ checked: boolean }>());

// Requests
export const loadSubscriptions = createAction(
  '[Api/Request Subscriptions] Load Subscriptions',
  (params: SubscriptionsParams, pageNumber: number = 1) => ({ params, pageNumber })
);

export const changeSubscriptionStatus = createAction('[Api/Request Subscriptions] Change Subscription Status', props<{ id: string }>());
